import React from 'react';
import PropTypes from 'prop-types';

const MenuItem = ({ label, link, className, onHover, onClick, withCloseButton }) => {
  return (
    <li onMouseOver={onHover}>
      <a onClick={onClick} className={className} href={link}>
        {label}
        {withCloseButton && <i className="icon-close-simple d-sm-inline-block" />}
      </a>
    </li>
  );
};

MenuItem.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  link: PropTypes.string,
  className: PropTypes.string,
  onHover: PropTypes.func,
  onClick: PropTypes.func,
  withCloseButton: PropTypes.bool,
};

MenuItem.defaultValue = {
  className: '',
  withCloseButton: false,
};

export default MenuItem;



// WEBPACK FOOTER //
// ./js/components/global/menu/MenuItem.js